import React, { useState, useEffect, useRef } from 'react';
import Footer from '../Footer/Footer';
import './FAQ.css';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

const faqData = {
  General: [
    {
      question: 'What is halwaa?',
      answer: 'halwaa is an iOS app by findhalal Inc. that helps you discover verified halal restaurants, read community reviews, and organize food events with friends.'
    },
    {
      question: 'Is the app free to use?',
      answer: 'Yes! halwaa is completely free for all users to download and explore.'
    },
    {
      question: 'How do you verify halal status?',
      answer: 'We verify data through a combination of direct calls to restaurants, official certifications, and community reports. Transparency is our top priority.'
    }
  ],
  Account: [
    {
      question: 'Do I need an account to browse?',
      answer: 'No, you can browse as a guest. However, creating an account allows you to rate places, save favorites, and join events.'
    },
    {
      question: 'How do I delete my account?',
      answer: 'You can request account deletion directly within the app settings or by contacting our support team at support@findhalal.us.'
    }
  ],
  Privacy: [
    {
      question: 'How is my location data used?',
      answer: 'We use your location solely to show you nearby halal restaurants. We do not track your location history or sell your data.'
    },
    {
      question: 'How is my profile data used?',
      answer: 'We use your age and gender only to curate the best algorithm for recommending other users near you who are also halal eaters. We never reveal your age or gender to other users.'
    }
  ],
  Partnerships: [
    {
      question: 'How can I partner with findhalal?',
      answer: 'We love collaborating with halal food businesses! Whether you run a restaurant, food truck, or home kitchen, you can join our platform to reach a wider audience.'
    },
    {
      question: 'Do you offer sponsorship opportunities?',
      answer: 'Yes! We offer premium placement and sponsorship packages to help boost your restaurant’s visibility directly on the halwaa app.'
    },
    {
      question: 'Can I promote my Ramadan specials?',
      answer: 'Absolutely. Ramadan is our busiest season, and we offer dedicated campaigns to feature your iftar and suhoor menus to thousands of local diners.'
    }
  ]
};

function FAQ() {
  const [openQuestions, setOpenQuestions] = useState({});
  const sections = Object.keys(faqData);
  const sectionRefs = useRef({});
  const [currentSection, setCurrentSection] = useState(sections[0]);

  sections.forEach((section) => {
    sectionRefs.current[section] = React.createRef();
  });

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setCurrentSection(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((section) => {
      const ref = sectionRefs.current[section];
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, [sections]);

  const handleSectionClick = (sectionName) => {
    setCurrentSection(sectionName);
    const sectionRef = sectionRefs.current[sectionName];
    if (sectionRef && sectionRef.current) {
      const offset = 100; // Offset for fixed header
      const elementPosition = sectionRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const toggleQuestion = (sectionName, index) => {
    setOpenQuestions((prev) => {
      const sectionOpen = prev[sectionName] || {};
      return {
        ...prev,
        [sectionName]: {
          ...sectionOpen,
          [index]: !sectionOpen[index]
        }
      };
    });
  };

  return (
    <>
      <div className="faq-page-container">
        <div className="faq-header">
          {/* Removed FadeInOnScroll to ensure visibility */}
          <h1 className="faq-title">Help Center</h1>
          <p className="faq-updated">How can we help you today?</p>
        </div>

        <div className="faq-layout">
          {/* Sidebar */}
          <div className="faq-sidebar">
            {sections.map((sectionName) => (
              <button
                key={sectionName}
                className={`sidebar-link ${currentSection === sectionName ? 'active' : ''}`}
                onClick={() => handleSectionClick(sectionName)}
              >
                {sectionName}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="faq-content">
            {sections.map((sectionName) => (
              <div
                key={sectionName}
                id={sectionName}
                ref={sectionRefs.current[sectionName]}
                className="faq-section"
              >
                <h2 className="faq-section-title">{sectionName}</h2>
                {faqData[sectionName].map((item, index) => {
                  const isOpen = openQuestions[sectionName]?.[index];
                  return (
                    <div className="faq-item" key={index}>
                      <div
                        className="faq-question"
                        onClick={() => toggleQuestion(sectionName, index)}
                      >
                        <span>{item.question}</span>
                        <span className="faq-icon">
                          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                        </span>
                      </div>
                      {isOpen && <div className="faq-answer">{item.answer}</div>}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FAQ;